import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "Create digital signage with Google Slides"),
  /*#__PURE__*/_createElementVNode("span", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.airsquirrels.com/ditto/google-slides/source/portal",
      target: "_blank",
      rel: "noreferrer noopener"
    }, "Get step-by-step instructions"),
    /*#__PURE__*/_createTextVNode(" to create digital signage using a Google Slides presentation.")
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "row"
}
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", null, "Edit Slide", -1)
const _hoisted_7 = { class: "callout callout--no-max" }
const _hoisted_8 = {
  class: "icon icon--x-large",
  viewBox: "0 0 24 24"
}
const _hoisted_9 = ["d"]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "Make all presentation edits in Google Slides. Ditto checks for presentation edits every 10 minutes.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    "hide-required-asterisk": "",
    ref: "form",
    "label-position": "top",
    model: _ctx.signageItemLayoutData
  }, {
    default: _withCtx(() => [
      (_ctx.isCreatingNewSignageItem)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                (_openBlock(), _createElementBlock("svg", _hoisted_8, [
                  _createElementVNode("path", { d: _ctx.mdiPencilOutline }, null, 8, _hoisted_9)
                ])),
                _hoisted_10
              ])
            ])
          ]))
    ]),
    _: 1
  }, 8, ["model"]))
}